import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { T } from '../../traks';
import { site_name } from '../../Site';

export const PremiumHeader = () => {
    return (
        <Row className="premium-banner premium-banner-container pt-5">
            <Container>
            <Col>
                <Row>
                    <Col sm="10" className="d-flex flex-column justify-content-end">
                        <h1 className='fw_900'><T>Get even more out of {site_name}! - Upgrade to premium</T></h1>
                        <p className='premium_banner_lead'><T>Are you ready to make your games even more fun, realistic, and educational? When you upgrade to Premium, you'll become the gamemaster and gain access to create games with many more possibilities. You choose how many users you want to invite to your Premium games, and you are free to choose from all the new setup options on {site_name}.</T></p>
                    </Col>
                    <Col sm="2 premium-img">
                        <img width="239" height="239" src='https://static.aktiedysten.dk/gfx/Om-1-300x300.png' alt="Hand holding a trophy" />
                    </Col>
                </Row>
            </Col>
            </Container>
        </Row>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumHeader.js